import { resolvePromisifiedAction } from './promisified-actions-actions';
export function createPromisifiedAction(action, dataSelector = (args) => null, errorSelector = (e) => e) {
    return (args, correlationId) => (dispatch) => {
        dispatch(action(...args)).then((result) => {
            return dispatch(resolvePromisifiedAction(true, correlationId, dataSelector(result)));
        }, (err) => {
            return dispatch(resolvePromisifiedAction(false, correlationId, errorSelector(err)));
        });
    };
}
//# sourceMappingURL=create-promisified-action.js.map